import React, { useEffect, useContext, useState, useRef } from 'react'
import { RendererContext } from '@/components/FURenderkit'
import { Button } from 'antd-mobile'
import '../AvatarDressup/index.scss'
import { RESOURCE_MANAGER } from '@/config'
import FUIcon from '../../Common/FUIcon'
import FacePupComp from '../AvatarDressup/components/FacePupComp'
import { Collapse } from 'antd'
import FacePupCompHeader from '../AvatarDressup/components/FacePupCompHeader'
import SaveAvatarBtn from '@/components/Common/SaveAvatarBtn'
import OverflowTooltip from '@/components/Common/OverflowTooltip'
import DressupBundle from './components/DressupBundle'
import BodyBundle from './components/BodyBundle'
import AvatarsTabContent from '../TalkSkill/components/AvatarsTabContent'
import { AvatarContext } from '@/components/RenderComp/Avatar'
import ColorBundle from './components/ColorBundle'
import { useAvatarEdit } from '@/hooks/useAvatarEdit'
import { useCollapse } from '@/hooks/useCollapse'
import classNames from 'classnames'

const CloudDressup = (props) => {
    const { style, initDressupPart, initDressupType } = props
    const { renderer } = useContext(RendererContext)
    const { avatarConfig, avatar } = useContext(AvatarContext)
    const [loadedBundle, setLoadedBundle] = useState<any[]>([])
    const avatarTabRef = useRef<any>(null)
    const {
        currentItems,
        gender,
        controlData,
        meshPoints,
        bodyPitchs,
        faceData,
        bodyData,
        clothesData,
        selectedDressupType,
        setMeshPoints,
        setBodyPitchs,
        dispatchTableData,
        selectedPartInControlData,
        selectedTypeInCurrentPart,
        currentFacepup,
        setSelectedDressupType,
        setSelectedTypeInCurrentPart,
        selectedDressupPart,
        setSelectedDressupPart,
        activeCollapsePanels,
        setActiveCollapsePanels,
        handleTypeSelect,
    } = useAvatarEdit(
        false,
        initDressupType,
        avatarConfig,
    )

    useEffect(() => {
        if (avatar) {
            flushIndexedDB()
        }
    }, [avatar])

    const [collapse, setCollapse] = useCollapse(renderer?.resize)

    function flushIndexedDB() {
        const map = RESOURCE_MANAGER._fileInfo as Map<string, any>
        setLoadedBundle(Array.from(map.keys()))
    }

    return (
        <div style={style} className="dressup-controller">
            <SaveAvatarBtn
                className="capture-btn"
                avatarTabRef={avatarTabRef}
            />
            <div className="dressup-part-selector">
                {
                    controlData.map(({
                        name,
                        normalIcon,
                        selectedIcon,
                        selectedColor,
                    }) => (
                        <FUIcon
                            className="dressup-part"
                            key={name}
                            style={{
                                'backgroundColor':
                                    selectedDressupPart === name ? selectedColor : '#fff',
                            }}
                            size="56px"
                            name={selectedDressupPart === name ? selectedIcon : normalIcon}
                            onClick={() => setSelectedDressupPart(name)}
                        />
                    ))
                }
            </div>
            <div className={
                classNames({
                    'dressup-pannel': true,
                    'hide': collapse
                })
            }>
                {
                    selectedDressupPart && selectedPartInControlData?.length > 1 && (
                        <div className="type-wrap better-scroll">
                            <div className="type-container">
                                {
                                    selectedPartInControlData.map(
                                        ({
                                            name,
                                            label,
                                            normalIcon,
                                            selectedIcon
                                        }) => (
                                            <div
                                                className={
                                                    `flex-center-align face-component ${selectedDressupType === name ? 'active' : ''}`
                                                }
                                                style={{
                                                    borderRadius: '16px',
                                                    flexDirection: 'column',
                                                    'backgroundColor': selectedDressupType === name
                                                        ? '#E0E0F6'
                                                        : '',
                                                }}>
                                                <FUIcon
                                                    key={name}
                                                    name={selectedDressupType === name ? selectedIcon : normalIcon}
                                                    size="32px"
                                                    onClick={() => handleTypeSelect(name)}
                                                />
                                                <span style={{ fontSize: '12px' }}>{label}</span>
                                            </div>
                                        )
                                    )
                                }
                            </div>
                        </div>
                    )
                }
                <div className='handler-wrap better-scroll'>
                    {
                        currentFacepup && currentFacepup.length > 1 && (
                            <div className='collapse-controllers'>
                                {
                                    selectedDressupPart && selectedDressupType && selectedTypeInCurrentPart && (
                                        <span
                                            className={activeCollapsePanels[0] === '1' ? 'active' : ''}
                                            onClick={() => setActiveCollapsePanels(['1'])}
                                        >
                                            {selectedTypeInCurrentPart.label}
                                        </span>
                                    )
                                }
                                {
                                    currentFacepup.map((facepup) => {
                                        return (
                                            <span
                                                className={activeCollapsePanels[0] === facepup.key ? 'active' : ''}
                                                onClick={() => setActiveCollapsePanels([facepup.key])}
                                            >
                                                {facepup.displayName}
                                            </span>
                                        )
                                    })
                                }
                            </div>
                        )
                    }
                    <Collapse
                        accordion
                        className='custom-collapse better-scroll'
                        activeKey={activeCollapsePanels}
                        onChange={(key) => {
                            setActiveCollapsePanels([key as string])
                        }}
                    >
                        {
                            selectedDressupPart && selectedDressupType && selectedTypeInCurrentPart && (
                                <Collapse.Panel
                                    key="1"
                                    header={
                                        <FacePupCompHeader
                                            name={selectedTypeInCurrentPart.label}
                                            Icon={
                                                <FUIcon
                                                    size="24px"
                                                    name={selectedTypeInCurrentPart.normalIcon}
                                                    style={{ marginRight: '8px' }}
                                                />
                                            }
                                        />
                                    }
                                    className='custom-collapse-item area-wrap'
                                >
                                    <div className='component-area better-scroll'>
                                        {
                                            selectedDressupType === 'my' ? (
                                                <AvatarsTabContent ref={avatarTabRef} />
                                            ) : (
                                                <>
                                                    <div className='component-list'>

                                                        {
                                                            currentItems.map((item) => {
                                                                if (selectedTypeInCurrentPart.type === 'color') {
                                                                    return (
                                                                        <ColorBundle
                                                                            item={item}
                                                                            selectedDressupPart={selectedDressupPart}
                                                                            setSelectedDressupPart={setSelectedDressupPart}
                                                                            setSelectedDressupType={setSelectedDressupType}
                                                                            selectedTypeInCurrentPart={selectedTypeInCurrentPart}
                                                                            setSelectedTypeInCurrentPart={setSelectedTypeInCurrentPart}
                                                                        />
                                                                    )
                                                                } else if (selectedTypeInCurrentPart.type === 'bundle' && item.icon_url) {
                                                                    return (
                                                                        <DressupBundle
                                                                            item={item}
                                                                            mode={'cloud'}
                                                                            faceData={faceData}
                                                                            clothesData={clothesData}
                                                                            dispatchTableData={dispatchTableData}
                                                                            loadedBundle={loadedBundle}
                                                                            currentItems={currentItems}
                                                                            selectedDressupPart={selectedDressupPart}
                                                                            selectedDressupType={selectedDressupType}
                                                                            selectedTypeInCurrentPart={selectedTypeInCurrentPart}
                                                                            setSelectedDressupPart={setSelectedDressupPart}
                                                                            setSelectedDressupType={setSelectedDressupType}
                                                                            setSelectedTypeInCurrentPart={setSelectedTypeInCurrentPart}
                                                                            flushIndexedDB={flushIndexedDB}
                                                                            controlData={controlData}
                                                                        />
                                                                    )
                                                                } else if (selectedTypeInCurrentPart.type === 'conf') {
                                                                    return (
                                                                        <BodyBundle
                                                                            item={item}
                                                                            bodyData={bodyData}
                                                                            dispatchTableData={dispatchTableData}
                                                                            selectedDressupPart={selectedDressupPart}
                                                                            setSelectedDressupPart={setSelectedDressupPart}
                                                                            setSelectedDressupType={setSelectedDressupType}
                                                                            selectedTypeInCurrentPart={selectedTypeInCurrentPart}
                                                                            setSelectedTypeInCurrentPart={setSelectedTypeInCurrentPart}
                                                                            bodyPitchs={bodyPitchs}
                                                                            setBodyPitchs={setBodyPitchs}
                                                                        />
                                                                    )
                                                                }
                                                                return null
                                                            })
                                                        }
                                                    </div>
                                                </>
                                            )
                                        }
                                    </div>
                                </Collapse.Panel>
                            )
                        }
                        {
                            currentFacepup.map((facepup) => {
                                return (
                                    <Collapse.Panel
                                        header={

                                            <FacePupCompHeader
                                                name={facepup.displayName}
                                                Icon={
                                                    facepup.icon ?
                                                        <FUIcon
                                                            size="24px"
                                                            name={facepup.icon(gender)}
                                                            style={{ marginRight: '8px' }}
                                                        /> : null
                                                }
                                            />
                                        }
                                        key={facepup.key}
                                        className='custom-collapse-item'
                                    >
                                        <FacePupComp
                                            facepup={facepup}
                                            selectedTypeInCurrentPart={selectedTypeInCurrentPart}
                                            meshPoints={meshPoints}
                                            bodyPitchs={bodyPitchs}
                                            setMeshPoints={setMeshPoints}
                                            setBodyPitchs={setBodyPitchs}
                                        />
                                    </Collapse.Panel>
                                )
                            })
                        }

                    </Collapse>
                </div>

            </div>
            {
                (
                    <>
                        <Button
                            className="apply"
                            size="small"
                            onClick={() => setCollapse(!collapse)}
                        >
                            收起
                        </Button>
                    </>
                )
            }
        </div>
    )
}

export default CloudDressup
